
/* Gryphon Singapore — One Treasures Box Per Cart */
(() => {
  if (window.__gryphonTreasuresOneBox) return;
  window.__gryphonTreasuresOneBox = true;

  const PRODUCT_ID = 15423026135074;
  const root = document.documentElement;

  const notice = document.createElement("div");
  notice.id = "gryphon-treasures-notice";
  notice.hidden = true;
  notice.setAttribute("role", "status");

  const style = document.createElement("style");
  style.textContent = `
    html.treasures-checking #inlineBYOBProducts,
    html.treasures-full #inlineBYOBProducts,
    html.treasures-error #inlineBYOBProducts {
      display: none !important;
    }

    #gryphon-treasures-notice {
      color: #5E6B47;
      border: 1px solid #D3D9CB;
      padding: 18px 20px;
      margin: 16px 0;
      font-size: 14px;
      line-height: 1.6;
    }

    #gryphon-treasures-notice[hidden] {
      display: none !important;
    }

    #gryphon-treasures-notice a {
      color: inherit;
      text-decoration: underline;
    }
  `;

  document.head.appendChild(style);

  function placeNotice() {
    const builder = document.getElementById(
      "inlineBYOBProducts"
    );

    if (builder &&
        notice.parentNode !== builder.parentNode) {
      builder.before(notice);
    }
  }

  let requestId = 0;

  async function checkCart() {
    const currentRequest = ++requestId;

    root.classList.add("treasures-checking");

    try {
      const base = window.Shopify?.routes?.root || "/";

      const response = await fetch(
        base + "cart.js",
        {
          credentials: "same-origin",
          cache: "no-store"
        }
      );

      if (!response.ok) throw new Error("Cart error");

      const cart = await response.json();

      if (currentRequest !== requestId) return;

      const quantity = cart.items.reduce(
        (total, item) => {
          if (Number(item.product_id) === PRODUCT_ID) {
            return total + item.quantity;
          }
          return total;
        }, 0
      );

      const hasTreasures = quantity >= 1;

      root.classList.toggle(
        "treasures-full",
        hasTreasures
      );

      root.classList.remove("treasures-error");

      if (hasTreasures) {
        notice.innerHTML = `
          <p>
            You already have a Create Your Own
            Treasures box in your basket.
            Limited to one box per order.
          </p>
          <a href="${window.Shopify?.routes?.root || "/"}cart">
            View your basket
          </a>
        `;
      } else {
        notice.innerHTML = "";
      }

      notice.hidden = !hasTreasures;
      placeNotice();

    } catch (error) {
      if (currentRequest !== requestId) return;

      root.classList.add("treasures-error");

      notice.textContent =
        "We couldn't check your basket. Please refresh the page.";

      notice.hidden = false;
      placeNotice();

    } finally {
      if (currentRequest === requestId) {
        root.classList.remove("treasures-checking");
      }
    }
  }

  root.classList.add("treasures-checking");

  const observer = new MutationObserver(placeNotice);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      checkCart,
      { once: true }
    );
  } else {
    checkCart();
  }

  window.addEventListener("pageshow", checkCart);
  window.addEventListener("focus", checkCart);

  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) checkCart();
  });
})();
